/**
* add your desired characters you want to allow.
* exception 1: if you want to allow double quote write it like: '"'
* note: the charactersAllowed always should be an array and each character you allowed should be wrap with single quote or double quote;
* example: ['a-z', 'A-Z', '0-9', '-', ' ', '_', '.', '"'];
*/

// const charactersAllowed = [
//   'a-z',
//   'A-Z',
//   '0-9',
//   'ü',
//   'ö',
//   'ä',
//   '-',
//   ' ',
//   '_',
//   '.',
//   '*',
//   '+',
//   '=',
//   '!',
//   '"'
// ];


const charactersAllowed = [
    'ü', 'Ü', 'ö', 'Ö', 'ä', 'Ä',
    ' ', '-', '_', '.', '*', '+', '=', '!', '"', ':', ';'
];